import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from "../../../forBinding";
import { getApiErrorMessage, toApiError } from "../utils";
import type { CreateParcelamentoDTO, ParcelamentoAPI } from "@practium/features/parcelling";

export const usePostParcelling = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async ({ typeParcelling = 'fixed', ...payload }: CreateParcelamentoDTO) => {
			try {
				return (
					await api.post<ParcelamentoAPI>(`/advices/parcelling/${typeParcelling}/create`, payload, {
						params: { forBinding },
					})
				).data;
			} catch (error) {
				throw toApiError(error, "Erro ao criar parcelamento");
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["parcelling"] });
		},
		onError: (error) => {
			console.error("Erro ao criar parcelamento:", getApiErrorMessage(error, "Erro ao criar parcelamento"));
		},
	});
};
